export default "__VITE_ASSET__bb154bc0__"